import i18n from "lib/i18n";
import { template } from "lodash";
import { View } from "backbone";
/* eslint-disable
    camelcase,
    class-methods-use-this,
    consistent-return,
    constructor-super,
    func-names,
    no-alert,
    no-constant-condition,
    no-eval,
    no-multi-assign,
    no-shadow,
    no-this-before-super,
    no-undef,
    no-underscore-dangle,
    no-unused-expressions,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
let CommentEditorControlsView;
export default CommentEditorControlsView = (function () {
  CommentEditorControlsView = class CommentEditorControlsView extends View {
    static initClass() {
      this.prototype.className = "comment-editor-controls-view";

      this.prototype.events = {
        "click .restore": "_handleRestore",
        "click .delete": "_handleDelete",
      };

      this.prototype.template = template(`\
<a class="moderation-control" href="mailto:<%- comment_user_email %>"><%- i18n.t('comment.button.email') %></a>
<a class="moderation-control" href="<%- editorial_comments_path %>"><%- i18n.t('comment.button.all_comments') %></a>
<a class="moderation-control restore" href="#"><%- i18n.t('comment.button.restore') %></a>
<a class="moderation-control delete" href="#"><%- i18n.t('comment.button.delete') %></a>\
`, { imports: { i18n } });
    }

    initialize(options) {
      this._handleRestore = this._handleRestore.bind(this);
      this._handleDelete = this._handleDelete.bind(this);
      this.comment_user_email = options.comment_user_email;
      this.comment_user_id = options.comment_user_id;
      return this.render();
    }

    render() {
      return this.$el.html(this.template({
        comment_user_email: this.comment_user_email,
        editorial_comments_path: this._editorialCommentsPathFor(this.comment_user_id),
      }),
      );
    }

    _handleRestore(event) {
      event.preventDefault();
      if (confirm(i18n.t("comment.messages.restore_comment"))) { return this.trigger("comment:restore"); }
    }

    _handleDelete(event) {
      event.preventDefault();
      if (confirm(i18n.t("comment.messages.remove_comment"))) { return this.trigger("comment:delete"); }
    }

    _editorialCommentsPathFor(user_id) {
      return `/editorial/comments?user_id=${user_id}`;
    }
  };
  CommentEditorControlsView.initClass();
  return CommentEditorControlsView;
}());
